import { DIMENSION_TITLES, MEASURE_TITLES } from '../analytics'
import { MEASURE_DEFINITION_BY_TITLE } from '../analyticsDefinitions'
import { EXPLORER_TYPE } from '../renderTypes'
import { useCustomizationStore } from '~/stores/customization'
import { CustomizationField } from '~/types/customization'
import { DashboardModuleType, type DashboardConfig } from '~/types/dashboards'

export const createPayrollDashboardConfig = (): DashboardConfig => {
  const customizationStore = useCustomizationStore()
  const employeeGroupDimension = customizationStore.getCustomizationByField(
    CustomizationField.EMPLOYEE_GROUP
  )

  return [
    {
      titleKey: 'dashboard.payroll.payMetrics',
      content: [
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey:
                'dashboard.payroll.sumPayrollTotalGrossConvertible.title',
              exploreLink: {
                measure:
                  MEASURE_TITLES.EMPLOYEE_SUM_PAYROLL_TOTAL_GROSS_CONVERTIBLE,
                dimension: employeeGroupDimension,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.EMPLOYEE_SUM_PAYROLL_TOTAL_GROSS_CONVERTIBLE
                ]
            },
            query: {
              measures: [
                MEASURE_TITLES.EMPLOYEE_SUM_PAYROLL_TOTAL_GROSS_CONVERTIBLE
              ]
            }
          }
        },
        {
          moduleType: DashboardModuleType.DISTRIBUTION,
          options: {
            config: {
              titleKey:
                'dashboard.payroll.variableAndBonusDistributionByType.title',
              exploreLink: {
                measure:
                  MEASURE_TITLES.EMPLOYEE_SUM_PAYROLL_VARIABLE_AND_BONUS_GROSS_CONVERTIBLE,
                dimension: DIMENSION_TITLES.EMPLOYEE_PAYROLL_CATEGORY,
                type: EXPLORER_TYPE.DOUGHNUT
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES
                    .EMPLOYEE_SUM_PAYROLL_VARIABLE_AND_BONUS_GROSS_CONVERTIBLE
                ]
            },
            query: {
              measures: [
                MEASURE_TITLES.EMPLOYEE_SUM_PAYROLL_VARIABLE_AND_BONUS_GROSS_CONVERTIBLE
              ],
              dimensions: [DIMENSION_TITLES.EMPLOYEE_PAYROLL_CATEGORY],
              limit: 5
            }
          }
        },
        {
          moduleType: DashboardModuleType.DOUBLE,
          options: {
            config: {
              titleKey:
                'dashboard.payroll.sumPayrollTotalGrossConvertible.title',
              firstSubtitleKey:
                'dashboard.payroll.sumPayrollBaseGrossConvertible.title',
              firstFillTrendMissingData: true,
              secondSubtitleKey:
                'dashboard.payroll.sumPayrollVariableAndBonusGrossConvertible.title',
              secondFillTrendMissingData: true,
              secondHasSpecialColor: true,
              exploreLink: {
                measure:
                  MEASURE_TITLES.EMPLOYEE_SUM_PAYROLL_TOTAL_GROSS_CONVERTIBLE,
                dimension: DIMENSION_TITLES.EMPLOYEE_PAYROLL_CATEGORY,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.EMPLOYEE_SUM_PAYROLL_TOTAL_GROSS_CONVERTIBLE
                ]
            },
            firstQuery: {
              measures: [
                MEASURE_TITLES.EMPLOYEE_SUM_PAYROLL_BASE_GROSS_CONVERTIBLE
              ]
            },
            secondQuery: {
              measures: [
                MEASURE_TITLES.EMPLOYEE_SUM_PAYROLL_VARIABLE_AND_BONUS_GROSS_CONVERTIBLE
              ]
            }
          }
        }
      ]
    },
    {
      titleKey: 'dashboard.moreData',
      content: [
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.payroll.countEmployeeFinance.title',
              exploreLink: {
                measure: MEASURE_TITLES.EMPLOYEE_COUNT_FINANCE,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.EMPLOYEE_COUNT_FINANCE
                ]
            },
            query: {
              measures: [MEASURE_TITLES.EMPLOYEE_COUNT_FINANCE]
            }
          }
        },
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.payroll.countFteHRAverage.title',
              exploreLink: {
                measure: MEASURE_TITLES.EMPLOYEE_AVERAGE_FTE_HR,
                type: EXPLORER_TYPE.KPI
              },
              withoutTrend: true,
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.EMPLOYEE_AVERAGE_FTE_HR
                ]
            },
            query: {
              measures: [MEASURE_TITLES.EMPLOYEE_AVERAGE_FTE_HR]
            }
          }
        },
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              withoutTrend: true,
              titleKey: 'dashboard.payroll.countCurrency.title',
              exploreLink: {
                measure: MEASURE_TITLES.EMPLOYEE_COUNT_CURRENCY,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.EMPLOYEE_COUNT_CURRENCY
                ]
            },
            query: {
              measures: [MEASURE_TITLES.EMPLOYEE_COUNT_CURRENCY]
            }
          }
        }
      ]
    }
  ]
}
